export interface State {
    latitude: null | number;
    longitude: null | number;
    visibleOnMap: boolean;
}

const initialState: State = {
    latitude: null,
    longitude: null,
    visibleOnMap: false,
};

export const UPDATE_MAP_DETAILS = 'UPDATE_MAP_DETAILS' as 'UPDATE_MAP_DETAILS';
export const updateMapDetails = (payload: State) => ({
    type: UPDATE_MAP_DETAILS,
    payload,
});

type Action = ReturnType<typeof updateMapDetails>;

export default (state = initialState, action: Action): State => {
    switch (action.type) {
        case UPDATE_MAP_DETAILS: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
};
